module.exports = __webpack_public_path__ + "img/intro_img_01_re.61715c52.png";